var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{attrs:{"svg":require('!svg-inline-loader?classPrefix!@mdi/svg/svg/exit-to-app.svg')}},[_vm._v(" 返回 ")])}
var staticRenderFns = []

export { render, staticRenderFns }